import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function FeaturedComic() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              精选推荐
            </h2>
            <p className="mt-1 text-sm text-foreground-500">
              编辑精选优质漫画，品质保证
            </p>
          </div>
          <Link
            to="/category"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs" />
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop="">
          {featuredComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}